<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 09 23 / ODOO-… (заказ Игоря: «для сегмента рабочей области добавь вкладку, на которой покажи doc.data_tasks, используя наш новый
             компонент меню; дополнительно покажи в нём бейдж со статусом»): вкладка «Tasks panel» формы стола — то же дерево задач, что на вкладке
             Tasks tree (doc.data_tasks), панелью функций в стиле 1С (MenuPanel inline: группы колонками, значки сегментов, поиск, избранное);
             у пункта — пилюля статуса последнего лога (те же цвета, что у колонки Status дерева), подсказка — комментарий и время запуска -->
        <!-- IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): логика пунктов (раскладка, значки, бейджи, открытие записи, избранное) — общий
             модуль utils/tasksPanel.js, тот же, что у панели задач в шапке AppTopbar (у администратора): вкладка и шапка показывают одно и то же -->
        <div class="attr-tasks-panel" ref="attr_container">
            <div v-if="!rows.length" class="atp-empty">{{ emptyText }}</div>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
            <MenuPanel v-else inline :items="items" :runsTitle="t('Tasks')" search :searchPlaceholder="t('Search tasks…')" :favKey="favKey" :favOf="favOf"
                :epoch="store._favEpoch" :favTitle="t('Favourite task (for this workspace)')" help="tasksTab" @pick="onPick" @fav="onFav" />
        </div>
    </Attr>
</template>

<script>
// IE 2026 09 23 / ODOO-… (заказ Игоря): ВКЛАДКА «TASKS PANEL» ФОРМЫ СТОЛА. Строки doc.data_tasks (attrs.attrs_viewTasks / prepare_taskTree:
// node {value, valueStr, attr_type, relation_segment, pi}; статусы Last log кладёт log.scan_log_multi при открытии формы: status, status_comment,
// created_at, cssClass-status) → пункты MenuPanel: строка с подчинёнными — папка (верхний уровень — группа), ссылка — только у узла AttrLink
// (клик открывает запись тем же путём, что двойной клик дерева: id = node.value, segment = node.relation_segment), use=false — пункт приглушён,
// бейдж — статус из словаря STATUS (title, cssClass элемента — как пилюля applyStatusChip в гриде), значок — node.pi (иконка сегмента с бэка),
// иначе иконка сегмента из словаря SEGMENTS (у подсегмента без иконки — родителя), иначе по типу узла. Избранное — личные пометки
// (menuFav_list / favorites_save, ключ tasks:<id записи стола>).
// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): сами правила живут в utils/tasksPanel.js (tasksPanel_flatten / _statusOf / _iconOf /
// _openAction / _favKey / _segments) — здесь только связка с виджетом: словари через стор, запись — подчинённым виджетом формы, кнопка «вставить»
// подсказки — в дерево ЭТОЙ записи (ctx.paste)
import { useMainStore } from '@/stores/mainStore'
import { tasksPanel_flatten, tasksPanel_openAction, tasksPanel_favKey, tasksPanel_segments } from '@/utils/tasksPanel'

export default {
    props: ['widget_id', 'attr_id'],
    data: () => ({
        WIDGET: {},
        attr: {},   // приходит из store.widget_attr_set
        tick: 0,
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    mounted() { this.dicts_request() },
    watch: {
        // перечитывание записи (Update data / select_log) — строки те же объекты не всегда: пересборка по окончании загрузки
        'WIDGET.loading'(v) { if (!v) { this.tick++; this.$nextTick(() => this.dicts_request()) } },
        rows() { this.dicts_request() },
    },
    computed: {
        binding() { return String(this.attr?.binding || 'doc.data_tasks') },
        recordId() { return String(this.WIDGET?.record?.id || '') },
        favKey() { return tasksPanel_favKey(this.recordId) },
        rows() {
            void this.tick
            // вотчеры Options API создаются РАНЬШЕ created() — первый прогон геттера идёт при WIDGET = {} (записи ещё нет): без записи строк нет
            const rec = this.WIDGET && this.WIDGET.record
            if (!rec || typeof rec !== 'object') return []
            const v = this.store.get_value(rec, this.binding)
            return Array.isArray(v) ? v : []
        },
        emptyText() { return this.t('No tasks: the tree {binding} of this record is empty', { binding: this.binding }) },   // IE 2026 09 23 / ODOO-341407: i18n
        items() {
            void this.store.itemsSource_change_index   // словари STATUS / SEGMENTS приходят позже строк — названия статусов и значки
            return tasksPanel_flatten(this.rows, this.ctx())
        },
    },
    methods: {
        content_Changed() { this.store.widget_attr_set(this) },
        dictRow(segment, id) {
            const IS = this.store.itemsSource?.[segment]
            if (!IS || id == null || id === '') return null
            return IS.ids?.[id] || (IS.data || []).find(x => x && String(x.id) === String(id)) || null
        },
        // контекст общего модуля: словари стора, формат даты запуска, перевод, запись-владелец для кнопки «вставить» подсказки
        ctx() {
            const store = this.store, rec = this.WIDGET?.record || {}
            return {
                dictRow: (segment, id) => this.dictRow(segment, id),
                listFolder: store.setting('fe.ux.treeListFolderOpen', true) !== false,   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка): ссылка на запись WIDGET-LIST — pi-folder-open (дефолт ВКЛ)
                formatDate: (s) => store.formatDateHTML(String(s), true),
                t: (text, params) => this.t(text, params),
                paste: rec.id ? { record: String(rec.id), segment: String(rec.segment || '') } : null,   // IE 2026 09 23 (заказ Игоря: кнопки в подсказках)
            }
        },
        // словари: статусы — целиком (их немного, как у пилюли грида); сегменты — только те, у чьих узлов нет своей иконки
        dicts_request() {
            const store = this.store
            try { store.get_itemsSource(this, {}, { attr_type: 'AttrLink', relation_segment: 'STATUS' }, { fetchMode: 'all' }) } catch (e) { /* без словаря — id статуса */ }
            const segs = tasksPanel_segments(this.rows)
            if (segs.length) { try { store.get_itemsSource(this, {}, { attr_type: 'AttrLink', relation_segment: 'SEGMENTS' }, { fetchMode: 'by_ids', ids: segs }) } catch (e) { /* значок по типу узла */ } }
        },
        // избранное — личные пометки ('@menus' умолчаний пользователя), ключ tasks:<id стола>, элемент — id записи узла
        favList() { return this.store.menuFav_list(this.favKey) },
        favOf(raw) { return raw?._open ? this.favList().includes(raw._open.id) : null },
        onFav(raw, on) {
            const id = raw?._open?.id
            if (!id || !this.recordId) return
            const cur = this.favList().filter(x => x !== id)
            this.store.favorites_save({ fav_menu: { key: this.favKey, items: on ? [...cur, id] : cur } })
        },
        // открыть запись узла — тот же путь, что у двойного клика дерева (mainStore widget_open: id = node.value, segment = node.relation_segment),
        // подчинённым виджетом формы стола
        onPick(raw) {
            const action = tasksPanel_openAction(raw?._open, { child: true })
            if (!action) return
            try {
                this.store.executeStoreMethod(this.WIDGET?.vueObj || this, action)
            } catch (e) { console.warn('AttrTasksPanel: open record failed', e) }
        },
    },
}
</script>

<style scoped>
.attr-tasks-panel { min-height: 60px; padding: 2px 0 6px; }
.atp-empty { padding: 14px 8px; color: var(--text-color-secondary, #6b7280); font-size: 12px; }
</style>
